import React from 'react';

import AppWrapper from 'components/apps/AppWrapper';
import NearestMedicalLocationFeatureSection from 'components/settings/projectConfiguration/NearestMedicalLocationFeatureSection';

export default function NearestMedicalLocationFeatureSectionWrapper({
  contextProps,
  wrappedProps,
}) {
  return (
    <AppWrapper {...contextProps}>
      <NearestMedicalLocationFeatureSection {...wrappedProps} />
    </AppWrapper>
  );
}
